<template>
  <el-dialog
			width="980px"
			:title="$t('callCenter.workbenchTitle')"
			:visible.sync="workbenchDialogVisible"
			:close-on-click-modal="false"
      @close="closePaymentFeesDialog"
			custom-class="workbench-dialog"
		>
    <!-- 转交线索 -->
    <TransferClue
      :showTransferClueDialog="handoverClueDialogVisible"
      :currentCustomId="currentCustomId"
      @update:clueList="handleUpdateClueList"
      @update:closeTransferClueDialog="handleCloseTransferClueDialog"
    />
    <div class="workbench-main">
      <div class="workbench-left">
        <div class="callout-wrap">
          <div class="out-name">{{ workbenchForm.customName }}</div>
          <div v-if="calloutInfo.type && calloutMapI18n[calloutInfo.type]" class="status-time" :class="{ 'active': calloutInfo.type !== 'after' }"> {{ calloutMapI18n[calloutInfo.type].status }} {{ callDuration }}</div>
          <p class="out-phone">{{ $t('callCenter.realPhone') }}{{ (isCallin ? callerPhone : calledPhone) || '--' }}</p>
          <p class="out-phone">{{ $t('callCenter.displayPhone') }}{{ (isCallin ? calledPhone : callerPhone) || '--' }}</p>
          <button v-if="calloutInfo.type && calloutMapI18n[calloutInfo.type] && calloutInfo.type && calloutMapI18n[calloutInfo.type].isEnd" @click="initCallCenter" class="out-btn begin-btn">{{ $t('callCenter.callNow') }}</button>
          <button v-else class="out-btn end-btn" @click="endCallout">{{ $t('callCenter.endCall') }}</button>
        </div>
        <ul v-if="followList.length > 0" class="callout-records">
          <li v-for="(item, index) in followList" :key="`${item.id}_${index}`">
            <div class="track-line"></div>
            <i class="track-dot"></i>
            <div class="track-item">
              <div class="track-time">{{ item.commucinateTime }}{{ item.followStatusStr }}</div>
              <p class="track-person">跟进人: {{ item.communicateName }}（{{ item.campusId }}）</p>
              <p class="track-info" :class="{ 'fold': item.isContentFold === 1 }">
                <span v-html="`跟进信息: ${item.communicateContent || '--'}`"></span>
                <span v-if="item.communicateContent.length > 0" @click="handleMore(item, index)" class="more-btn">{{ $t('app.more') }}<i></i></span>
              </p>
              <div class="track-images">
                <template v-if="item.pictures.length > 0">
                  <img v-for="(pic, index) in item.pictures"
                    :key="index" width="36" height="36" :src="pic.src" />
                </template>
              </div>
            </div>
          </li>
        </ul>
        <div v-else>
          <el-empty :image-size="60" :description="$t('callCenter.noFollowYet')"></el-empty>
        </div>
      </div>
      <div class="workbench-right">
        <el-form :model="workbenchForm" size="small" label-position="left">
          <div class="workbench-form">
            <el-row :gutter="16" class="row-bottom-8">
              <el-col :span="7">
                <el-form-item label-width="90px" class="custom-form-item" :label="$t('callCenter.cluePhone')">
                  <span>{{ workbenchForm.phone }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label-width="78px" class="custom-form-item" :label="$t('callCenter.clueSource')">
                    <span>{{ workbenchForm.firstSourceStr || '' }}</span>
                  </el-form-item>
              </el-col>
              <el-col :span="9">
                  <el-form-item label-width="82px" class="custom-form-item" :label="$t('callCenter.followPerson')">
                    <span>{{ workbenchForm.ownerName }}</span>
                  </el-form-item>
              </el-col>
            </el-row>
            <!-- 第二行 -->
            <el-row :gutter="16" class="row-bottom-8">
              <el-col :span="7">
                <el-form-item label-width="90px" class="custom-form-item" :label="$t('callCenter.studentName') + ':'">
                  <el-input v-model="workbenchForm.studentName" :placeholder="$t('callCenter.pleaseFill')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label-width="78px" class="custom-form-item" :label="$t('callCenter.grade') + ':'">
                    <el-select
                      style="width: 45%;"
                      :disabled="!studentDetails.isEditStageGrade && !!studentDetails.isStudent"
                      v-model="workbenchForm.stage"
                      @change="changeStage"
                      :placeholder="$t('callCenter.pleaseSelect')"
                    >
                      <el-option
                        v-for="item in stageList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                    <el-select
                    style="width: 55%;"
                    :disabled="!studentDetails.isEditStageGrade && !!studentDetails.isStudent"
                    v-model="workbenchForm.grade"
                    :placeholder="$t('callCenter.pleaseSelect')">
                      <el-option v-for="item in gradeListI18n" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                    <p v-if="studentDetails.isStudent === 1" style="line-height:14px;font-size:10px;color:#F53F3F;margin-left:2px;">{{ $t('callCenter.gradeEditOnce') }}</p>
                  </el-form-item>
              </el-col>
              <el-col :span="9">
                  <el-form-item label-width="82px" class="custom-form-item" :label="$t('callCenter.familyMember1') + ':'">
                  <el-row :gutter="2">
                    <el-col :span="11">
                      <el-select v-model="workbenchForm.relationBackup">
                        <el-option v-for="item in relationshipList" :key="item.id" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="workbenchForm.phoneBackup"
                        :placeholder="$t('callCenter.phonePlaceholder')"
                        oninput="if(value.length>11){value=value.slice(0,11)}"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第三行 -->
            <el-row :gutter="16" class="row-bottom-8">
              <el-col :span="7">
                <el-form-item label-width="90px" class="custom-form-item" :label="$t('callCenter.studentGender') + ':'">
                  <el-radio-group v-model="workbenchForm.sex">
                    <el-row :gutter="12">
                      <el-col :span="12">
                        <el-radio :label="1">{{ $t('callCenter.male') }}</el-radio>
                      </el-col>
                      <el-col :span="12">
                        <el-radio :label="2">{{ $t('callCenter.female') }}</el-radio>
                      </el-col>
                    </el-row>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label-width="78px" class="custom-form-item" :label="$t('callCenter.school') + ':'">
                    <el-select v-model="workbenchForm.school" filterable remote
                        :remote-method="searchSchool" @change="selectSchool">
                        <el-option v-for="item in schoolList"
                          :key="item.id" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="9">
                  <el-form-item label-width="82px" class="custom-form-item" :label="$t('callCenter.familyMember2') + ':'">
                  <el-row :gutter="2">
                    <el-col :span="11">
                      <el-select v-model="workbenchForm.relationBackupTwo">
                        <el-option v-for="item in relationshipList" :key="item.id" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="workbenchForm.phoneBackupTwo"
                        :placeholder="$t('callCenter.phonePlaceholder')"
                        oninput="if(value.length>11){value=value.slice(0,11)}"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" class="row-bottom-8">
              <el-col :span="7">
                <el-form-item label-width="90px" class="custom-form-item" :label="$t('callCenter.birthday') + ':'">
                  <el-date-picker
                    type="date"
                    v-model="workbenchForm.birthday"
                    :placeholder="$t('callCenter.pleaseSelect')"
                    style="width: 100%"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label-width="78px" class="custom-form-item" :label="$t('callCenter.homeAddress') + ':'">
                    <el-input v-model="workbenchForm.homeAddress" :placeholder="$t('callCenter.pleaseFill')" maxlength="100"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="9">
                  <el-form-item label-width="82px" class="custom-form-item" :label="$t('callCenter.intentLevel') + ':'">
                  <el-select style="width:95.83%;" v-model="workbenchForm.intend">
                    <el-option v-for="item in intendList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" class="row-bottom-8">
              <el-col :span="7">
                <el-form-item label-width="90px" class="custom-form-item" :label="$t('callCenter.tag') + ':'">
                  <el-select v-model="workbenchForm.labels" style="width: 100%" multiple>
                    <el-option v-for="item in followStatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item label-width="82px" class="custom-form-item" :label="$t('callCenter.remark') + ':'">
                  <el-input type="textarea" rows="1" autosize v-model="workbenchForm.remark" :placeholder="$t('callCenter.pleaseFill')" maxlength="200"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="workbench-follow">
            <el-form-item label-width="100px"  class="custom-form-item" :label="$t('callCenter.followStatus') + ':'">
              <!-- <el-select
                v-model="workbenchForm.followStatus"
                :placeholder="$t('callCenter.pleaseSelectFollowStatus')"
                style="width: 200px"
              >
                <el-option
                  v-for="item in followStatusOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select> -->
              <el-radio-group v-model="workbenchForm.followStatus" >
                <el-radio
                  style="margin-right: 5px;border-radius:16px;"
                  v-for="item in followStatusOptionsI18n"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                  border>{{ item.value }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label-width="100px" class="custom-form-item" :label="$t('callCenter.nextFollowTime') + ':'">
              <el-date-picker
                v-model="workbenchForm.nextCommunicateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                :default-time="new Date().toLocaleTimeString()"
                :picker-options="pickerOptions"
                :placeholder="$t('callCenter.pleaseSelect')"
                style="width: 200px"
              >
              </el-date-picker>
            </el-form-item>
            <div v-if="workbenchForm.followStatus === 6005003 || workbenchForm.followStatus === 6005005">
              <el-form-item label-width="100px" :label="workbenchForm.followStatus === 6005003 ? $t('callCenter.promiseVisitTime') : $t('callCenter.visitTime')" prop="cometoTime">
                  <el-date-picker v-model="workbenchForm.cometoTime" :default-time="new Date().toLocaleTimeString()"
                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="pickerOptions"
                    :placeholder="workbenchForm.followStatus === 6005003 ? $t('callCenter.selectPromiseVisitTime') : $t('callCenter.selectVisitTime')"
                    style="min-width: 200px;">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label-width="100px" :label="$t('callCenter.visitStore')" prop="cometoStoreId">
                <el-select v-model="workbenchForm.cometoStoreId" :placeholder="$t('callCenter.pleaseSelectVisitStore')" style="width: 230px;">
                  <el-option v-for="item in storeList" :key="item.key" :label="item.value"
                    :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- 跟进描述 -->
            <el-form-item label-width="100px" :label="$t('callCenter.followDesc')">
              <el-input
                style="width: 100%;"
                type="textarea"
                :placeholder="$t('callCenter.pleaseFill')"
                v-model="workbenchForm.communicateContent"
                maxlength="200"
                :rows="5"
                show-word-limit
              >
              </el-input>
            </el-form-item>

            <div class="custom-form-footer">
                <el-button @click="toTransferCustom">{{ $t('callCenter.transferClue') }}</el-button>
                <el-button @click="saveRecord" class="save-btn">{{ $t('callCenter.saveRecord') }}</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import pubsub from 'pubsub-js';
import { queryBaseSchool } from "@/api/RefundInterface";
import { getDictionaryListI18n } from "@/api/basicApi";
import { getEnableClueTagConfig } from "@/api/CampusList";
import { customArticleCallCenter, listRecord, updateCustomInfoAndRecord } from "@/api/studentDetails";
import LoginUserHelper from "@/util/LoginUserHelper";
import TransferClue from "@/components/TransferClue.vue";
export default {
  data() {
    return {
      workbenchDialogVisible: false,
      campusId: LoginUserHelper.getUserInfo().campusId,

      // 工作台
      workbenchForm: {
        customId: '',
        customName: '',
        phone: '',
        studentName: '',
        stage: '',
        grade: '',
        relationBackup: 6002001,
        phoneBackup: '',
        relationBackupTwo: 6002001,
        phoneBackupTwo: '',
        sex: 1,
        schoolId: '',
        school: '',
        birthday: '',
        homeAddress: '',
        intend: '',
        followStatus: '',
        labels: [],
        remark: '',
        nextCommunicateTime: '',
        cometoTime: '',
        cometoStoreId: '',
        communicateContent: '',

        firstSourceStr: '',
        ownerName: '',
      },
      studentDetails: {},
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
			},
			pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      schoolList: [],
      stageList: [],
      schoolData: {
        '6003004': [
          {
            id: 6004023,
            name: this.$t('app.auto_358_de3dbeff'),
          },
          {
            id: 6004024,
            name: this.$t('app.auto_359_e011300b'),
          },
          {
            id: 6004025,
            name: this.$t('app.auto_360_cd722ca1'),
          },
        ],
        "6003001": [
          {
            id: 6004001,
            name: this.$t('app.auto_361_694fc5e7')
          },
          {
            id: 6004002,
            name: this.$t('app.auto_362_4df5bd40')
          },
          {
            id: 6004003,
            name: this.$t('app.auto_363_7373adfb')
          },
          {
            id: 6004004,
            name: this.$t('app.auto_364_59a9aa58')
          },
          {
            id: 6004005,
            name: this.$t('app.auto_365_01ad86b3')
          },
          {
            id: 6004006,
            name: this.$t('app.auto_366_8ce6b148')
          }
        ],
        "6003002": [
          {
            id: 6004006,
            name: this.$t('app.auto_366_8ce6b148')
          },
          {
            id: 6004007,
            name: this.$t('app.auto_368_0431dfa1')
          },
          {
            id: 6004008,
            name: this.$t('app.auto_369_d05aef19')
          },
          {
            id: 6004009,
            name: this.$t('app.auto_370_dc32dacc')
          }
        ],
        "6003003": [
          {
            id: 6004010,
            name: this.$t('app.auto_371_391d9d87')
          },
          {
            id: 6004011,
            name: this.$t('app.auto_372_b7098df1')
          },
          {
            id: 6004012,
            name: this.$t('app.auto_373_1888db71')
          },
          {
            id: 6004013,
            name: this.$t('app.auto_374_259e9142')
          }
        ]
      },
			gradeList: [],
			intendList: [],
      relationshipList: [],
      followStatusOptions: [
        { key: 6005009, value: this.$t('app.auto_623_77451e5c') },
        { key: 6005010, value: this.$t('app.auto_624_a921024f') },
        { key: 6005003, value: this.$t('app.auto_625_6dbd04d4') },
        { key: 6005005, value: this.$t('app.auto_626_c3cdab96') },
        { key: 6005006, value: this.$t('app.auto_627_2c036380') },
        { key: 6005007, value: this.$t('app.auto_623_77451e5c') },
      ],

      // 转交线索
      handoverClueDialogVisible: false,

      followList: [], // 历史跟进记录
      totalCount: 0, // 数据总长度
      pageSize: 50, // 每页条数
      pageIndex: 1, // 当前页码
      followStatusList: [], // 标签
      calloutMap: {
        makecall: {
          status: this.$t('app.auto_629_0678b836'),
          isEnd: false,
        },
        outcall: {
          status: this.$t('app.auto_630_10a00a86'),
          isEnd: false,
        },
        outringing: {
          status: this.$t('app.auto_631_c32f7c23'),
          isEnd: false,
        },
        calledringing: {
          status: this.$t('app.auto_632_c3c6c0b6'),
          isEnd: false,
        },
        after: {
          status: this.$t('app.auto_633_3d13bc80'),
          isEnd: true,
        },
        agentidle: {
          status: this.$t('app.auto_634_f6020e93'),
          isEnd: true,
        },
        calledringing: {
          status: this.$t('app.auto_635_820490f6'),
          isEnd: false,
        },
        playtts: {
          status: this.$t('app.auto_636_10cc60c3'),
          isEnd: false,
        },
        incall: {
          status: this.$t('app.auto_637_4718bdad'),
          isEnd: false,
        },
        answer: {
          status: this.$t('app.auto_638_f7a633c5'),
          isEnd: false,
        },
      }, // 呼叫状态映射
      calloutInfo: {}, // 外呼状态显示信息
      callDuration: '00:00:00',
      callerPhone: '--',
      calledPhone: '--',
    }
  },
  props: {
    showWorkbenchDialog: {
      type: Boolean,
      default: false
    },
    // 是否是呼入
    isCallin: {
      type: Boolean,
      default: false
    },
    currentCustomId: {
      type: String,
      default: '',
    },
    // 外部传入外呼手机号
    callPhone: {
      type: String,
      default: '',
    },
  },
  components: {
    TransferClue,
  },
  computed: {
    calloutMapI18n() {
      const t = (k) => this.$t('callCenter.' + k);
      return {
        makecall: { status: t('callMakecall'), isEnd: false },
        outcall: { status: t('callOutcall'), isEnd: false },
        outringing: { status: t('callOutringing'), isEnd: false },
        calledringing: { status: t('callConnecting'), isEnd: false },
        after: { status: t('callAfter'), isEnd: true },
        agentidle: { status: t('callAgentidle'), isEnd: true },
        playtts: { status: t('callPlaytts'), isEnd: false },
        incall: { status: t('callIncall'), isEnd: false },
        answer: { status: t('callAnswer'), isEnd: false }
      };
    },
    followStatusOptionsI18n() {
      const t = (k) => this.$t('callCenter.' + k);
      const keyMap = { 6005009: 'followPhone', 6005010: 'followWechat', 6005003: 'followPromise', 6005005: 'followVisit', 6005006: 'followInvalid', 6005007: 'followDeal' };
      return this.followStatusOptions.map(o => ({ ...o, value: keyMap[o.key] ? t(keyMap[o.key]) : o.value }));
    },
    gradeListI18n() {
      const t = (k) => this.$t('callCenter.' + k);
      const keyMap = { 6004023: 'stageK1', 6004024: 'stageK2', 6004025: 'stageK3', 6004001: 'grade1', 6004002: 'grade2', 6004003: 'grade3', 6004004: 'grade4', 6004005: 'grade5', 6004006: 'grade6', 6004007: 'grade7', 6004008: 'grade8', 6004009: 'grade9', 6004010: 'gradeH1', 6004011: 'gradeH2', 6004012: 'gradeH3', 6004013: 'gradeH4' };
      return (this.gradeList || []).map(item => ({ ...item, name: keyMap[item.id] ? t(keyMap[item.id]) : item.name }));
    }
  },
  watch: {
    showWorkbenchDialog: {
      handler(newVal, oldVal) {
        this.workbenchDialogVisible = newVal;
        if (newVal) {
          this.resetForm();
          this.loadStudentDetail(true);
          this.getFollowData();
          this.initCallCenterEvents();
        }
      },
      immediate: true
    },
  },
  async mounted() {
    // 获取学校数据
		await queryBaseSchool({ campusId: null, search: "" }).then((ret) => {
			if (ret.code === 0) {
				this.schoolList = ret.data;
			}
		});
		await getDictionaryListI18n({ typeId: 6002 }, this.$i18n.locale).then((ret) => {
			if (ret.code === 0) {
				this.relationshipList = ret.data;
			}
		});
    //获取阶段、年级默认
    await getDictionaryListI18n({ typeId: 6003 }, this.$i18n.locale).then((ret) => {
      if (ret.code === 0) {
        this.stageList = ret.data;
      }
    });
		// 获取意向级别
		await getDictionaryListI18n({ typeId: 6007 }, this.$i18n.locale).then((ret) => {
			if (ret.code === 0) {
				this.intendList = ret.data;
			}
		});

    CallCenter.addEventListener("callingAnswerTimer", (json) => {
      this.callDuration = json.time;
    });
          //获取标签
    const { campusId, id } = LoginUserHelper.getUserInfo();
    const res = await getEnableClueTagConfig({ campusId, userId: id, tagType: 0 });
    const { code, data = {} } = res;
    const { tagList = [] } = data;
    if (code === 0) {
        const options = tagList.map(({ tagCode, tagName }) => ({
            id: tagCode,
            name: tagName
        }));
        this.followStatusList = options;
    }
  },
  methods: {
    resetForm() {
      this.callDuration = '00:00:00';
      this.calloutInfo = {};
      this.workbenchForm = {
        customId: '',
        customName: '',
        phone: '',
        studentName: '',
        stage: '',
        grade: '',
        relationBackup: 6002001,
        phoneBackup: '',
        relationBackupTwo: 6002001,
        phoneBackupTwo: '',
        sex: 1,
        schoolId: '',
        school: '',
        birthday: '',
        homeAddress: '',
        intend: '',
        followStatus: '',
        labels: [],
        remark: '',
        nextCommunicateTime: '',
        cometoTime: '',
        cometoStoreId: '',
        communicateContent: '',

        firstSourceStr: '',
        ownerName: '',
      }
    },
    // 点击查看更多
    handleMore(item, index) {
      this.$set(this.followList[index], 'isContentFold', item.isContentFold ? 0 : 1);
    },
    // 初始化外呼
    initCallCenter() {
      const callPhone = this.callPhone || this.workbenchForm.phone;
      CallCenter.callout(callPhone);
    },
    // 结束外呼
    endCallout() {
      const status = CallCenter.getStatus()
      if (status !== 'agentidle') {
        CallCenter.cancelmakecall();
      }
    },
    // 初始化外呼事件
    initCallCenterEvents() {
      if (!window.workbenchCallouter) {
        window.workbenchCallouter = (json) => {
          if (!this.workbenchDialogVisible) return;
          const { type } = json;
          if (type != 'ping' && type != 'queuenum' && type != 'callinfo') {
            this.calloutInfo = json || {};
          }
          this.callerPhone = CallCenter.getCaller() || '--';
          this.calledPhone = CallCenter.getCalled() || '--';
          const status = CallCenter.getStatus();
          if (!['answer', 'incall'].includes(status)) {
            const duration = CallCenter.getCallDuration();
            this.callDuration = CallCenter.secondsToHours(duration);
          }
        };
      }

    },
    // 保存记录
    saveRecord() {
      const labels = this.workbenchForm.labels?.map(item => ({ labelNo: item })) || [];
      const params = {
        ...this.workbenchForm,
        labels: labels
      }
      updateCustomInfoAndRecord(params).then((ret) => {
        if (ret.code === 0) {
          this.$message({ message: this.$t('callCenter.saveSuccess'), type: "success" });
          this.loadStudentDetail();
          this.updatePage();
        } else {
          this.$message({ message: this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('callCenter.saveFail'), type: "warning" });
        }
      })
    },
    // 更新页面
    updatePage() {
      const currentPath = this.$route.path;
			if (
				currentPath.indexOf('/main/AgentStudentDetails') > -1 ||
				['/main/outboundRecords', '/main/AgentpotentialStudentList'].includes(currentPath)
			) {
        pubsub.publish('workbench-custom-update', {});
			}
    },
    // 转交线索成功后更新用户信息
    handleUpdateClueList() {
      this.loadStudentDetail();
    },
    handleCloseTransferClueDialog () {
      this.handoverClueDialogVisible = false;
    },
    // 转交线索按钮点击
    toTransferCustom() {
      this.handoverClueDialogVisible = true;
    },
    // 获取外呼工作台的静态数据-历史跟进记录
    async getFollowData() {
      const params = {
        param: {
          customId: this.currentCustomId,
          followUpType: 1  // 跟进类型 1.手动跟进, 2.自动跟进
        },
        pageIndex: this.pageCurrent,
        pageSize: this.PageSize,
      };
      await listRecord(params).then(ret => {
        if (ret.code === 0) {
          for (let i = 0; i < ret.data.body.length; i++) {
            ret.data.body[i].isContentFold = 1;
          }
          this.totalCount = ret.data.count;
          this.followList = ret.data.body;
        }
      });
    },
    loadStudentDetail(isFirstLoad = false) {
      const params = {
        customId: this.currentCustomId
      }
      customArticleCallCenter(params).then(ret => {
        if (ret.code === 0) {
          this.studentDetails = ret.data;
          this.workbenchForm.customId = this.studentDetails.customId;
          this.workbenchForm.customName = this.studentDetails.customName;
          this.workbenchForm.phone = this.studentDetails.phone;
          this.workbenchForm.studentName = this.studentDetails.studentName;
          this.workbenchForm.stage = this.studentDetails.stage || '';
          this.workbenchForm.grade = this.studentDetails.grade || '';
          this.workbenchForm.relationBackup = this.studentDetails.relationBackup || 6002001;
          this.workbenchForm.phoneBackup = this.studentDetails.phoneBackup;
          this.workbenchForm.relationBackupTwo = this.studentDetails.relationBackupTwo || 6002001;
          this.workbenchForm.phoneBackupTwo = this.studentDetails.phoneBackupTwo;
          this.workbenchForm.sex = this.studentDetails.sex;
          this.workbenchForm.schoolId = this.studentDetails.schoolId || '';
          this.workbenchForm.school = this.studentDetails.school;
          this.workbenchForm.birthday = this.studentDetails.birthdayStr;
          this.workbenchForm.homeAddress = this.studentDetails.homeAddress;
          this.workbenchForm.intend = this.studentDetails.intend;
          this.workbenchForm.followStatus = this.studentDetails.followStatus;

          this.workbenchForm.ownerName = this.studentDetails.ownerName;
          this.workbenchForm.firstSourceStr = this.studentDetails.firstSourceStr;
          // 年级联动信息
          this.gradeList = this.studentDetails.stage ? this.schoolData[this.studentDetails.stage] : [];
          // 立即呼出
          if (isFirstLoad) {
            if (this.isCallin) {
              CallCenter.acceptcall();
            } else {
              this.initCallCenter();
            }
          }
        }
      })
    },
    async searchSchool(item) {
      await queryBaseSchool({ campusId: null, search: item }).then((ret) => {
        if (ret.code === 0) {
          this.schoolList = ret.data;
        }
      });
    },
    changeStage(val) {
      this.gradeList = this.schoolData[val] || [];
      this.workbenchForm.grade = '';
    },
		selectSchool(item) {
      this.workbenchForm.schoolId =
        this.schoolList.find((v) => v.name == item).id || null;
    },
    closePaymentFeesDialog() {
      this.endCallout();
      this.workbenchDialogVisible = false;
      if (window.workbenchCallouter) {
        window.workbenchCallouter = undefined;
      }
      this.$emit('closeWorkbenchDialog');
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-checkbox__original {
  display: none !important;
}

::v-deep .el-checkbox:focus:not(.is-focus):not(:active):not(.is-disabled) .el-checkbox__inner {
    box-shadow: none !important;
}
// 线索转交
.handover-clue {
	padding: 0 20px;
	.handover-tip {
		line-height: 24px;
		margin-bottom: 12px;
		color: #333;
		font-size: 14px;
	}
	.help-text {
		color: #EE4B4E;
		font-size: 12px;
		line-height: 18px;
		margin-top: 2px;
	}
	.form-item-staff {
		margin-bottom: 0;
	}
}
.round-checkbox {
	margin-right: 6px;
	border-radius: 16px !important;
	::v-deep .el-checkbox__input {
		display: none;
	}
	::v-deep .el-checkbox__label {
		padding-right: 1px;
		padding-left: 6px;
	}
}
</style>
<style lang="scss">
// 外呼工作台
.workbench-dialog {
	border-radius: 8px;
	.el-dialog__header {
		padding: 14px 26px;
		background: rgb(74, 131, 232);
		border-radius: 8px 8px 0px 0px;
		.el-dialog__title, .el-dialog__close {
			color: #fff;
		}
	}
	.el-dialog__body {
		padding: 16px 8px 36px 0;
	}
	.workbench-main {
		display: flex;
		.workbench-left {
			width: 198px;
			.callout-wrap {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				.out-name {
					width: 66px;
					height: 66px;
          line-height: 66px;
					background: #1890FF;
					border-radius: 50%;
					color: #fff;
					font-size: 16px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
				}
				.status-time {
					padding: 12px 0;
					font-weight: 500;
					font-size: 16px;
          color: #999;
					&.active {
						color: #00B42A;
					}
					&.inactive {
						color: #999;
					}
				}
				.out-phone {
					color: #666;
					font-size: 12px;
				}
				.out-btn {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 134px;
					height: 32px;
					margin-top: 12px;
					outline: none;
					border: 0 none;
					color: #fff;
					border-radius: 4px;
					font-size: 14px;
					cursor: pointer;
					&.begin-btn {
						background: #00B42A;
					}
					&.end-btn {
						background: #EE4B4E;
					}
				}
			}
			.callout-records {
				margin-top: 28px;
				overflow-y: auto;
				max-height: 256px;
				&::-webkit-scrollbar {
					width: 3px;
					height: 3px;
					cursor: pointer;
				}
				&::-webkit-scrollbar-track {
					border-radius: 3px;
					background: linear-gradient(90deg,rgba(255,255,255,1) 0%,rgba(255,255,255,1) 25%,rgba(234,242,250,1)25%,rgba(234,242,250,1) 75%,rgba(255,255,255,1) 75%,rgba(255,255,255,1) 100%);
				}
				&::-webkit-scrollbar-thumb {
					border-radius: 3px;
					background:linear-gradient(180deg,rgba(49,179,255,1) 0%,rgba(157,247,247,1) 100%);
				}
				li {
					position: relative;
					padding-left: 36px;
					.track-item {
						padding-bottom: 12px;
						padding-right: 18px;
						.track-time {
							line-height: 18px;
							font-size: 14px;
							color: #333;
						}
						.track-person, .track-info {
							position: relative;
							line-height: 18px;
							color: #666;
							font-size: 12px;
						}
						.track-info {
              position: relative;
							margin-bottom: 8px;
							padding-right: 36px;
              &.fold {
                white-space: nowrap;
							  overflow: hidden;
							  text-overflow: ellipsis;
              }
							.more-btn {
								position: absolute;
								left: 106px;
                top: 0;
								width: 38px;
								color: #1890FF;
								font-size: 12px;
								cursor: pointer;
								> i {
									display: inline-block;
									content: '';
									transform: translateY(-50%);
									border: solid #1890FF;
									border-width: 0 1px 1px 0;
									margin-bottom: 3px;
									margin-left: 2px;
									padding: 3px;
									transform: rotate(45deg);
								}
							}
						}
						.track-images {
							display: flex;
							align-items: center;
							> img {
								display: block;
								margin-right: 8px;
								border-radius: 4px;
							}
						}
					}
					.track-line {
						position: absolute;
						width: 1px;
						height: 100%;
						top: 0;
						left: 24px;
						background-color: #ccc;
						z-index: -1;
					}
					.track-dot {
						position: absolute;
						left: 20px;
						top: 6px;
						width: 8px;
						height: 8px;
						border-radius: 50%;
						background: #1890FF;
						z-index: 1;
					}
				}
			}
		}
		.workbench-right {
			flex: 1;
			.workbench-form {
				padding: 16px;
				background: #F6F9FD;
				border-radius: 4px;
				.custom-form-item {
					margin-bottom: 0;
				}
				.row-bottom-8 {
					margin-bottom: 8px;
				}
				.row-bottom-12 {
					margin-bottom: 12px;
				}
			}
			// 跟进状态
			.workbench-follow {
				padding: 24px 16px 0;
				.custom-form-item {
					margin-bottom: 12px;
				}
				.custom-form-footer {
					display: flex;
					justify-content: flex-end;
					padding-top: 6px;
					margin-bottom: 0;
					> button {
						width: 134px;
						color: #1890FF;
						border: 1px solid #1890FF;
						&.save-btn {
							background: #1890FF;
							color: #fff;
						}
					}
				}
			}
		}
	}
}
</style>